// extracted by mini-css-extract-plugin
export var documentIcon = "moreFiles-module--documentIcon--tHwdD";
export var documentText = "moreFiles-module--documentText--qks7W";
export var documentWrapper = "moreFiles-module--documentWrapper--JjeMZ";